var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.986,
    height: 129.634,
    viewBox: "0 0 134.986 129.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10790",
    "data-name": "Group 10790",
    transform: "translate(-1936.084 -859.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10795",
    "data-name": "Group 10795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10794",
    "data-name": "Group 10794",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M38.066,0c26.867,0,69.4,29.5,69.4,56.366s-5.687,57.869-35.363,57.869S0,86.042,0,56.366,11.2,0,38.066,0Z",
    transform: "translate(2049.392 852.669) rotate(79)",
    fill: "none",
    stroke: "#cef5d6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M38.066-1.666c26.867,0,69.4,29.5,69.4,56.366S101.78,112.569,72.1,112.569,0,84.376,0,54.7,11.2-1.666,38.066-1.666Z",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 1944.342, 866.783)",
    fill: "#e3fde8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10788",
    "data-name": "Group 10788",
    transform: "translate(1982.256 902.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M24.892,21.3a1.64,1.64,0,0,1-1.23-.558c-1.361-1.558-3.411-3.789-6.249-6.823a1.64,1.64,0,0,1,2.395-2.231c2.87,3.051,4.92,5.3,6.314,6.888a1.64,1.64,0,0,1-1.23,2.723Z",
    transform: "translate(5.991 2.281)",
    fill: "#30db50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M17.713,25.961c-5.806,0-9.513-8.824-9.513-13.449a9.513,9.513,0,1,1,19.025,0C27.225,17.138,23.518,25.961,17.713,25.961Zm0-19.681a6.232,6.232,0,0,0-6.232,6.232c0,3.739,3.083,10.169,6.232,10.169s6.232-6.429,6.232-10.169A6.232,6.232,0,0,0,17.713,6.28Z",
    transform: "translate(0.328 -3)",
    fill: "#30db50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M24.321,39.082H18.236A13.219,13.219,0,0,1,6.9,32.751a4.559,4.559,0,0,1-.623-2.345,4.674,4.674,0,0,1,.607-2.313,83.954,83.954,0,0,1,7.02-7.479c1.64,2.952,4.117,5.347,7.134,5.347,5.806,0,9.513-8.824,9.513-13.449a9.513,9.513,0,0,0-19.025,0,15.417,15.417,0,0,0,.951,4.92C5.8,24.157,4.46,25.8,4.066,26.47A7.79,7.79,0,0,0,3,30.406a7.938,7.938,0,0,0,1.082,4.018,16.516,16.516,0,0,0,14.154,7.938h6.085a1.64,1.64,0,0,0,0-3.28Zm-3.28-32.8a6.232,6.232,0,0,1,6.232,6.232c0,3.739-3.083,10.169-6.232,10.169-1.985,0-3.936-2.559-5.117-5.379a1,1,0,0,0-.082-.2,13.121,13.121,0,0,1-1.033-4.592A6.232,6.232,0,0,1,21.041,6.28Z",
    transform: "translate(-3 -3)",
    fill: "#30db50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M27.2,35.4a8.2,8.2,0,1,1,8.2-8.2A8.2,8.2,0,0,1,27.2,35.4Zm0-13.121a4.92,4.92,0,1,0,4.92,4.92A4.92,4.92,0,0,0,27.2,22.28Z",
    transform: "translate(7.241 7.241)",
    fill: "#30db50"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.436589938f17e7feb21b863232f84d9e.svg";
export { ForwardRef as ReactComponent };